import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';

export const AbstructVar = () => {
    let langLocal = localStorage.getItem('pentalensLang');
    let mode = localStorage.getItem('mode-pentalens');
    let dispatch = useDispatch();
    let navigate = useNavigate();
    return {
        dispatch,
        navigate,
        langLocal,
        mode
    }
}

export const renderContentHTML = (content) => {
    return { __html: content };
}